export enum CallDirection {
    INBOUND = 'inbound',
    OUTBOUND_API = 'outbound-api',
    OUTBOUND_DIAL = 'outbound-dial',
}